import React from 'react'
import styled from "styled-components";

const Line = styled.div`
    position: absolute;
    width: 100%;
    height: fit-content;
    top: -100px;
    right: 0;

    @media (min-width: 1920px){
        right: 0;
    }

    @media (max-width: 1620px){
        display: none;
    }
`;

const Left = styled.div`
    width: 45%;
    height: 2px;
    top: 5px;
    border-top: 2px dashed #38393B;
    left: 2.5%;
    position: absolute;
`;

const Right = styled.div`
    width: 45%;
    height: 2px;
    top: 5px;
    border-top: 2px dashed #38393B;
    right: 2.5%;
    position: absolute;
`;

const Center = styled.div`
    background-color: #38393B;
    width: 12px;
    height: 12px;
    top: 0;
    left: calc(50% - 6px);
    position: absolute;
    transform: rotate(45deg);
`;

const SplitLine = () => {
    return (
        <Line>
            <Left />
            <Center />
            <Right />
        </Line>
    )
}

export default SplitLine
